import { Link } from 'react-router-dom';

const stats = [
  { value: '12', label: '集正片' },
  { value: '9', label: '剧情节点' },
  { value: '8', label: '主要演员' },
  { value: '47', label: '酒吧场景出现次数' },
];

export default function AboutStrip() {
  return (
    <section className="w-full border-t border-background-200/60 bg-secondary-900 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
        <div>
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-primary-500"></span>
            <span className="font-label text-xs tracking-[0.3em] text-primary-400">ABOUT THE ARCHIVE</span>
          </div>
          <h2 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-3xl">
            这是一个把"看剧之后想说的话"整理好的地方
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-400">
            我们不做评分，也不做排行榜。这个站点只做三件事：把剧情按时间线拆开讲清楚，把演员对角色的理解记录下来，把剧集相关的报道与讨论收集在一起。
          </p>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-500">
            站内所有人物、情节与资讯均为虚构示例，用于展示影视内容站的内容组织方式，不涉及真实人物的评价或奖项信息。
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
            >
              了解本站
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-600/60 px-5 py-2.5 text-sm text-foreground-300 transition-colors hover:border-primary-500/50 hover:text-primary-300"
            >
              <i className="ri-search-line"></i>
              搜索站内内容
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-secondary-700/50 bg-secondary-950/40 p-4 md:p-5"
            >
              <p className="font-heading text-2xl font-black text-primary-400 md:text-3xl">{stat.value}</p>
              <p className="mt-1 text-xs leading-relaxed text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}